module.exports = __webpack_public_path__ + "img/placeholder.f0f8f5b5.jpg";